import * as css from 'css/exports.module.scss';
import './Record.scss';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { ifClickHandler } from '@lib/events';
import { SonarRecordContainer } from './RecordContainer';
import { SonarRecordNameSection } from './RecordNameSection';
import { SonarRecordReferences } from './RecordReferences';
import { SonarRecordRelationships } from './RecordRelationships';
import { SonarRecordRow } from './RecordRow';
import { SonarRecordSecondaryInfo } from './RecordSecondaryInfo';
import { SonarText } from '../text';
import { When } from 'react-if';
import { Col, Space } from 'antd';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import React, { useMemo } from 'react';
export const SonarRecord = ({ children, className, isActive, isDeleted, name, onClick, onClickParent, parentName, relatedCounts, relatedOrgs, relatedField, rightEnd, secondaryInfo, sonarObjectId, sonarObjectType, source, versionNumber, showType }) => {
    const handleOnClickParent = useMemo(() => ifClickHandler(onClickParent), [onClickParent]);
    const showRelatedCounts = sonarObjectType !== SonarObjectType.SalesforceEntity;
    return (React.createElement(SonarRecordContainer, { className: className, onClick: onClick },
        React.createElement(SonarRecordRow, null,
            React.createElement(Col, { className: 'primary-info', flex: 'none' },
                React.createElement(Space, { size: Number(css.size8) },
                    React.createElement(SonarRecordNameSection, { isActive: isActive, name: name, onClickParent: handleOnClickParent, parentName: parentName, versionNumber: versionNumber }),
                    React.createElement(SonarRecordRelationships, { relatedField: relatedField, relatedOrgs: relatedOrgs, source: source }),
                    React.createElement(SonarRecordReferences, { parentName: parentName, relatedCounts: showRelatedCounts ? relatedCounts : undefined, sonarObjectId: sonarObjectId !== null && sonarObjectId !== void 0 ? sonarObjectId : 0 }),
                    React.createElement(When, { condition: isDeleted },
                        React.createElement(SonarText, { type: 'danger' }, COPY_SPECIFIC.DELETED)))),
            React.createElement(SonarRecordSecondaryInfo, { info: secondaryInfo, sonarObjectType: showType ? sonarObjectType : undefined }),
            rightEnd),
        children));
};
